export default __webpack_public_path__ + "static/media/Flag_of_Peru.9cdba94a.svg";